// pdfCache.js
import * as pdfjsLib from "pdfjs-dist";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";

// PDF.js 워커 설정
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

// 캐시: { [pdfUrl]: Promise<PDFDocumentProxy> }
const pdfDocCache = {};

export async function getCachedPdfDocument(pdfUrl) {
    // 이미 캐시에 있으면, 그걸 반환
    if (pdfDocCache[pdfUrl]) {
        return pdfDocCache[pdfUrl];
    }
    // 없으면 다운로드 + 캐시에 저장
    pdfDocCache[pdfUrl] = pdfjsLib.getDocument(pdfUrl).promise;
    return pdfDocCache[pdfUrl];
}